import { useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "./axiosInstance";

export interface MapAddressRequest {
    cd: string;
}
export interface MapAddressResponse {}

export const usePostMapAddress = (successCallback?: (data: MapAddressResponse) => void) => {
    return useMutation({
        mutationFn: async (data: MapAddressRequest) => {
            const response = await axiosInstance.post(enum_api_uri.ADDRESS_LIST, data);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
